import React, { Component } from 'react';

import { Card, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CircularProgress from 'material-ui/CircularProgress';
import AddressField from '../elements/AddressField';

import { Details as styles } from './form.css';
import Config from '../../conf';

const washTypes = Config.WASH_TYPES;

class Details extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      bookButtonDisabled: false,
      error: false,

      bookingCompleted: false
    };


    this.keyTyped = this.keyTyped.bind(this);
    this.nextDisabled = this.nextDisabled.bind(this);
    this.fieldChanged = this.fieldChanged.bind(this);
  }

  fieldChanged(fieldName, newValue) {
    this.props.setHasError(fieldName, false);
    this.props.updateField(fieldName, newValue);
  }

  nextDisabled() {
    const carDetails = this.props.details.numberPlate || this.props.details.carBrandColor;
    const carLocation = this.props.details.carParkSpot || this.props.details.carParkLevel || this.props.details.carParkLevelColor;
    let ret = !this.props.details.phone ||
      !carDetails || !carLocation ||
      !this.props.details.carType;
    return ret;
  }

  keyTyped(field, value) {
    if (field === 'phone' && value && value.length >= 10) {
      this.getCustomerInfo(value);
    }
    this.props.setHasError(field, false);
    this.props.updateField(field, value);
  }

  washSelect(washTypeName) {
    if (!washTypeName)
      return;
    const washTypeTmp = JSON.parse(JSON.stringify(washTypes));
    const washType = washTypeTmp.filter(function (wash) {
      return wash.name === washTypeName;
    })[0];    
    const washDuration = this.props.details.washDetails[washTypeName].duration - 0.5;
    const washTypeDisplay = washType.displayName;
    let extraWashPrice = 0;
    if (this.props.details.carType.toUpperCase() === 'SUV') {
      extraWashPrice = 10;
    } else if (this.props.details.carType.toUpperCase() === 'VAN') {
      extraWashPrice = 20;
    }
    const washPrice = this.props.details.washDetails[washTypeName].cost + (extraWashPrice);
    this.props.updateField('washType', washTypeName);
    this.props.updateField('washDuration', washDuration);
    this.props.updateField('washTypeDisplay', washTypeDisplay);
    this.props.updateField('washPrice', washPrice);
    
    this.props.next();
  }

  getCustomerInfo(phone) {
    new Promise((resolve, reject) => {
      fetch(Config.BACKEND_API_URL + 'carpark/getcustomer', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phone: phone
        })
      }).then(response => {
        return response.json().then(data => {
          if (data.status === 200) {
            resolve(data);
          } else {
            throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
          }
        });
      }).catch(err => {
        reject(err);
      });
    }).then((response) => {
      if (!response.details)
        return;  
      const details = response.details;
/*   
      phone */
      switch (details.car_type) {
        case 'sedan':
          details.car_type = 'Sedan';
          break;
        case 'suv':
          details.car_type = 'SUV';
          break;
        case 'van':
          details.car_type = 'Van';
          break;
      }
      
      details.full_name = details.full_name && details.full_name.indexOf('Parking Member') > -1 ? '' : details.full_name;
      details.number_plate = details.number_plate ? details.number_plate.toUpperCase() : ''
      
      this.keyTyped('name', details.full_name);
      this.keyTyped('email', details.email);
      this.keyTyped('numberPlate', details.number_plate);
      this.keyTyped('carType', details.car_type);
    });
  }

  render() {
    let extraWashPrice = 0;
    if (this.props.details.carType.toUpperCase() === 'SUV') {
      extraWashPrice = 10;
    } else if (this.props.details.carType.toUpperCase() === 'VAN') {
      extraWashPrice = 20;
    }
    return (
      <div>
        {!this.state.error && !this.state.loading && !this.state.bookingCompleted &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Welcome</h2>
            <br />
            <h4 style={styles.subTitle}>Please fill out your contact details and select your clean</h4>
            <div style={styles.wrapper}>
            <TextField
                style={styles.field}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Mobile Number *'}
                floatingLabelText={this.props.details.phone ? 'Mobile Number' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.phone}
                onChange={(evt) => this.keyTyped('phone', evt.target.value.replace(/[^0-9\s]/g, ''))}
                errorText={this.props.details.phoneError ? 'Please fill in this field' : ''}
                maxLength={20}
              />            
              <TextField
                style={styles.field}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Name (optional)'}
                floatingLabelText={this.props.details.name ? 'Name' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.name}
                onChange={(evt) => this.keyTyped('name', evt.target.value)}
                errorText={this.props.details.nameError ? 'Please fill in this field' : ''}
                maxLength={50}
              />
              <TextField
                style={styles.field}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Email Address (optional)'}
                floatingLabelText={this.props.details.email ? 'Email Address' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.email}
                onChange={(evt) => this.keyTyped('email', evt.target.value)}
                errorText={this.props.details.emailError ? 'Please fill in this field' : ''}
                maxLength={64}
              />
              <p style={{ paddingTop: 15 }}>What type of car do you have?</p>
              <SelectField
                style={styles.textField}
                floatingLabelText=""
                value={this.props.details.carType}
                onChange={this.props.setCarType}
              >
                <MenuItem value={'Sedan'} primaryText="Sedan" />
                <MenuItem value={'SUV'} primaryText="SUV" />
                <MenuItem value={'Van'} primaryText="Van" />
              </SelectField>
              <p style={{ paddingTop: 15 }}>Car Location</p>
              <TextField
                style={{ ...styles.field, width: '30%' }}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Level'}
                floatingLabelText={this.props.details.carParkLevel ? 'Level' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.carParkLevel}
                onChange={(evt) => this.keyTyped('carParkLevel', evt.target.value)}
                errorText={this.props.details.carParkLevelError ? 'Please fill in this field' : ''}
                maxLength={2}
              />or
            <TextField
                style={{ ...styles.field, width: '30%' }}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Level Color'}
                floatingLabelText={this.props.details.carParkLevelColor ? 'Level Color' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.carParkLevelColor}
                onChange={(evt) => this.keyTyped('carParkLevelColor', evt.target.value)}
                errorText={this.props.details.carParkLevelColorError ? 'Please fill in this field' : ''}
                maxLength={20}
              />or
            <TextField
                style={{ ...styles.field, width: '30%' }}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Spot Number'}
                floatingLabelText={this.props.details.carParkSpot ? 'Spot Number' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.carParkSpot}
                onChange={(evt) => this.keyTyped('carParkSpot', evt.target.value.replace(/[^0-9]/g, ""))}
                errorText={this.props.details.carParkSpotError ? 'Please fill in this field' : ''}
                maxLength={5}
              />
              <p style={{ paddingTop: 15 }}>Car Details</p>
              <TextField
                style={{ ...styles.field, width: '45%' }}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Number Plate'}
                floatingLabelText={this.props.details.numberPlate ? 'Number Plate' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.numberPlate}
                onChange={(evt) => this.keyTyped('numberPlate', evt.target.value.toUpperCase())}
                errorText={this.props.details.numberPlateError ? 'Please fill in this field' : ''}
                maxLength={10}
              />or
            <TextField
                style={{ ...styles.field, width: '45%' }}
                hintStyle={styles.hintStyle}
                inputStyle={styles.inputStyle}
                hintText={'Car Brand & Color'}
                floatingLabelText={this.props.details.carBrandColor ? 'Car Brand & Color' : ' '}
                floatingLabelFixed={true}
                value={this.props.details.carBrandColor}
                onChange={(evt) => this.keyTyped('carBrandColor', evt.target.value)}
                errorText={this.props.details.carBrandColorError ? 'Please fill in this field' : ''}
                maxLength={100}
              />
              <div style={styles.center}>
                <p style={{ paddingTop: 15 }}>Wash Type?</p>
                {this.props.details.washDetails &&
                  <div style={styles.flexContainer}>
                    {washTypes.map((washType, idx) => {
                      return (
                        <Card
                          style={{ ...styles.cardContainer, backgroundColor: this.props.details.washType == washType.name ? '#d0f3a3' : '' }}
                          key={washType.name}
                        >
                          <h2 style={styles.cardTitle}>{washType.displayName}</h2>
                          <h5 style={styles.cardSubTitle}>{washType.subTitle}</h5>
                          <CardText
                            style={styles.subcard}
                          >
                            <ul style={styles.list}>
                              {washType.points.map((point, idx) => {
                                return (
                                  <li key={idx} style={styles.li}>{point}</li>
                                );
                              })}
                            </ul>
                          </CardText>
                          <div style={styles.priceText}>
                            ${(this.props.details.washDetails[washType.name].cost + (extraWashPrice)).toFixed(2)}
                          </div>
                          <br />
                          <RaisedButton
                            label="Select"
                            secondary={true}
                            style={styles.chooseButton}
                            onClick={this.washSelect.bind(this, washType.name)}
                            disabled={this.nextDisabled()}
                          />
                        </Card>
                      );
                    })}
                  </div>
                }
              </div>
            </div>
          </Card>
        }
      </div>
    );
  }
}

export default Details;



// WEBPACK FOOTER //
// ./src/app/components/form/Details.js